module.exports = __webpack_public_path__ + "img/service-resource05.2586736e.jpg";